@if (!store.$langLoaded()) {
  <app-loading />
}
<div class="registration__background registration__background___light">
  @if (store.$langLoaded()) {
    <router-outlet />
  }
</div>
